import React, { Component } from 'react';
import { confirmAlert } from 'react-confirm-alert';
import { SelectField } from 'react-md';
import { NotificationManager } from 'react-notifications';
import LoadingSpinner from '../component/LoadingSpinner';
import ApiRequestService from './ApiRequestService';
import { AppSetting } from '../common/function'

export default class TimeZone extends Component  {
    AppSetting = AppSetting();

    constructor(props){
        super(props);

        this.state = {
            currentTimeZone: '',
            loading:false
        };
    }

    componentWillMount(){
        this.getTimeZone();
    }
    //APIs
    getTimeZone = async() =>{
        this.setState({loading:true});
        let getTimeZoneResp = await  ApiRequestService({
            method: 'post',
            url: '/getTimeZone'
        });

        try{
            if(getTimeZoneResp && getTimeZoneResp.data && getTimeZoneResp.data.data){
                window.localStorage.setItem(`${this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX}_timeZone`, getTimeZoneResp.data.data);
                this.setState({currentTimeZone:getTimeZoneResp.data.data});
            }else if(getTimeZoneResp.data && getTimeZoneResp.data.status && getTimeZoneResp.data.message ){
                NotificationManager.error("Get TimeZone Failed with Error - "+getTimeZoneResp.data.message,"Error",5000);
            }else{
                NotificationManager.error("Get TimeZone Failed with Unknown Error","Error",5000);
            }
        }catch(err){
            NotificationManager.error("Get TimeZone Failed with Error "+err,"Error",5000);
        }finally{
            this.setState({loading:false});
        }
    }

    updateTimeZone = async(timeZoneStr) =>{
        this.setState({loading:true});
        confirmAlert({
            title: 'Are you sure want to change the Timezone? ',
            message: 'Press Confirm to submit',
            cancelLabel: 'Confirm',
            confirmLabel: 'Cancel',
            onCancel: async() => {
                let getTimeZoneResp = await  ApiRequestService({
                    method: 'post',
                    url: '/addTimeZone',
                    data:JSON.stringify(timeZoneStr)
        
                });
        
                try{
                   if(getTimeZoneResp.data && getTimeZoneResp.data.status && getTimeZoneResp.data.message ){
                        NotificationManager.error("Add TimeZone Failed with Error - "+getTimeZoneResp.data.message,"Error",5000);
                    }else{
                        this.setState({currentTimeZone:timeZoneStr})
                    }
                }catch(err){
                    NotificationManager.error("Add TimeZone Failed with Error "+err,"Error",5000);
                }finally{
                    this.setState({loading:false});
                }
            },
            onConfirm: () =>{
                this.setState({loading:false});
            }
          });
        
    }

    //Events
    onChange = (value) => {
        this.preTimeZoneValue = this.state.currentTimeZone;
        this.updateTimeZone(value); 
    }
    render(){
        if(this.state.loading){
            return <LoadingSpinner loading={this.state.loading} />
        }
        return <fieldset className='archive-btn-field-set'>
                <legend>*Server Time Zone*</legend>
                <ul className='archive-btn-list'>
                    <li>Server Time Zone should not be changed in the middle of the semester as this would cause errors in Score Calculations and Assignment Timings </li>
                </ul>
                <SelectField
                    className="archive-button"
                    id="select-time-zone"
                    placeholder="Select a Time Zone"
                    menuItems={timeZones}
                    position={SelectField.Positions.BELOW}
                    value={this.state.currentTimeZone}
                    onChange={this.onChange}
                    itemLabel='label'
                    fullWidth
                />
            </fieldset>
    }
}



const timeZones  = 
[
    {'value':'America/New_York','label':'Eastern Time'},
    {'value':'America/Los_Angeles','label':'Pacific Time'},
    {'value':'America/Denver','label':'Mountain Time'},
    {'value':'America/Phoenix','label':'Mountain Standard Time'},
    {'value':'America/Chicago','label':'Central Time'},
    {'value':'Asia/Kolkata','label':'Indian Standard Time'},
]